// Sends cart events to the backend, which writes them to Application Insights.
function toItems(list) {
  return (list || []).map(i => ({ id: i.id, quantity: Number(i.quantity) || 1 }));
}

export function trackCartEvent(action, items, cart) {
  try {
    fetch('api/Cart/Track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action, items: toItems(items), cart: toItems(cart) }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    // telemetry must never break the shop
  }
}
